import { render, staticRenderFns } from "./UnlayerHeaderEditor.vue?vue&type=template&id=0abe4982&"
import script from "./UnlayerHeaderEditor.vue?vue&type=script&lang=js&"
export * from "./UnlayerHeaderEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports